<template>
  <validation-provider tag="div" :rules="rules" :name="name || label" v-slot="{errors}" :vid="vid">
    <v-autocomplete
      :label="label"
      class="search-input"
      @keyup.prevent="search"
      :error-messages="errors[0]"
      v-bind="$attrs"
      :item-text="itemText"
      dense
      @input="val => $emit('input', val)"
      :value="value"
      :item-value="itemValue"
      outlined>
      <template v-if="customSelection" #selection="{item, index}">
        <slot name="selection" :item="item" :index="index"></slot>
      </template>
      <template #prepend-inner>
        <v-progress-circular
          v-show="loading"
          size="18"
          width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </template>
      <template #no-data v-if="customNoData">
        <slot name="no-data"></slot>
      </template>
      <template #prepend-item v-if="prependItem">
        <slot name="prepend:item"></slot>
      </template>
    </v-autocomplete>
  </validation-provider>
</template>

<script>
import {debounce} from "@/utils/pureFunctions";

export default {
  name: 'custom-autocomplete',
  props: {
    prependItem: {
      type: Boolean,
      default: false
    },
    customNoData: {
      type: Boolean,
      default: false
    },
    customSelection: {
      type: Boolean,
      default: false
    },
    value: {},
    name: {},
    vid: {},
    label: {},
    rules: {},
    delay: {
      type: Number,
      default: 300
    },
    itemText: {
      type: String | Function,
      default: 'name'
    },
    itemValue: {
      type: String | Function,
      default: 'id'
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    clear() {
    }
  },
  created() {
    this.search = debounce(function (e) {
      this.$emit('search', e.target.value)
    }, this.delay)
  }
}

</script>